import {
	AttemptState, deepMerge, DeepPartial, GlobalState, State, StateDataSource
} from "@sabyr-dev/mist_core/model/datasource/state";
import { Question } from "@sabyr-dev/mist_elibrary/datasource";
import { Annotations } from "@sabyr-dev/mist_core/lib/userdata";
import { AcademyLocalDatabase } from "./idb";
import {
	StateInitializer
} from "@sabyr-dev/mist_core/model/datasource/stateinitializer";

export interface AcademyAttemptState extends AttemptState {
	userData: Record<Question, Annotations & {
		status?: 'correct' | 'incorrect' | 'unanswered'
	}>;
	cookie: string;
	testId: string;
	testName: string;
	productId: string;
	attemptId: number;
	mode: string;
	started: Date;
}

export abstract class AcademyStateDataSource<S extends State> extends StateDataSource<S> {
	abstract getStoreName(): string;

	local: AcademyLocalDatabase;

	constructor(initializer: StateInitializer<S>) {
		super(initializer);
		this.local = new AcademyLocalDatabase();
	}

	async getState(): Promise<S> {
		const db = await this.local.getDb();
		return await db.get(this.getStoreName(), this.getStateKey());
	}

	async setState(state: Omit<S, "timestamp"> & Partial<Pick<S, "timestamp">>): Promise<void> {
		const db = await this.local.getDb();
		await this.local.write(this.getStoreName(), `set${Date.now()}`, async (transaction) => {
			transaction.store.put(state, this.getStateKey());
			return true;
		});
	}

	async updateState(state: DeepPartial<S>): Promise<void> {
		await this.local.write(this.getStoreName(), `update${Date.now()}`, async (transaction) => {
			const current = await transaction.store.get(this.getStateKey()) as S;
			const newState = deepMerge(current, state);
			await transaction.store.put(newState, this.getStateKey());
			return true;
		});
	}
}

export class AcademyGlobalStateDataSource extends AcademyStateDataSource<GlobalState> {
	getStoreName(): string {
		return AcademyLocalDatabase.global;
	}

	getStateKey(): string {
		return this.local.getGlobalKey();
	}
}

export class AcademyAttemptStateDataSource extends AcademyStateDataSource<AcademyAttemptState> {
	getStoreName(): string {
		return AcademyLocalDatabase.attempt;
	}

	getStateKey(): string {
		return this.local.getAttemptKey();
	}
}
